import { FC } from 'react'
import Link from '@components/ui/Link'
import { useRouter } from 'next/router'
import cn from 'clsx'
import s from './index.module.css'

interface Link {
  Label: string,
  Link: string,
}

interface Props {
  navItems: Link[]
}
const CategoryNav: FC<Props> = ({ navItems }) => {
  const { asPath } = useRouter()

  return (
    <>
      <div className="flex w-full overflow-x-auto mt-6 mb-2 scrollbar-hide">
        <div className="flex flex-row gap-2.5 mx-auto pl-4">
          {navItems.map((link) => (
            <Link
              key={link.Label}
              className={cn('px-4 py-2 border rounded-sm text-body2 shrink-0', {
                'border-brand-chrome': asPath === link.Link,
                'border-ui-grey-25 hover:opacity-75': asPath !== link.Link,
              })}
              href={link.Link}
            >
              {link.Label}
            </Link>
          ))}
          <div className={s.padding_compensate}></div>
        </div>
      </div>
    </>
  )
}

export default CategoryNav
